/**
 * Viewport bucketing for analytics. Single source of truth for the breakpoints
 * so the boot-time `viewport` super-property (instrumentation-client.ts) and the
 * per-event `viewport` prop (app-shell) never disagree.
 *
 * Breakpoints mirror the app-shell chrome split: <700 mobile, 700-1023 tablet,
 * >=1024 desktop.
 */
export type Viewport = 'mobile' | 'tablet' | 'desktop';

export function viewportBucket(width: number): Viewport {
  if (width < 700) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
}

/** Current viewport bucket, or `undefined` on the server (SSR-safe). */
export function currentViewport(): Viewport | undefined {
  if (typeof window === 'undefined') return undefined;
  return viewportBucket(window.innerWidth);
}
